export const getResourceDetails = (ics_resources,resource_id) => {
  const resource = ics_resources.find((res) => res.id === resource_id);
  return resource ? { kind: resource.kind, type: resource.type } : { kind: '', type: '' };
};